import {IStrapiEntity, StrapiUtils} from "services/strapi";
import {ListItemsTable, ListItemsTableProps} from "components/common";
import {IProject, TableSettings} from "features/projects";
import {RoutesResolver} from "routes";

interface Props extends Omit<ListItemsTableProps<
    IProject & { id: number },
    void>,
    'settings' | 'data'> {

    data?: IStrapiEntity<IProject>[]
}

export function ProjectsListTable({data, ...rest}: Props){
    const routesResolver = new RoutesResolver()
    return (
        <ListItemsTable
            {...rest}
            data={StrapiUtils.flattenStrapiEntities(data)}
            settings={TableSettings({
                routesResolver,
            })}
        />
    )
}